import { createFileRoute } from '@tanstack/react-router'
import { LoginForm } from '@/components/login-form'
import { requireGuest } from '@/lib/route-guards'
import { LoadingProvider, useLoading } from '@/contexts/loading-context'
import { LoadingModal } from '@/components/ui/loading-modal'
import { z } from 'zod'

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: requireGuest,
  component: () => (
    <LoadingProvider>
      <LoginPage />
    </LoadingProvider>
  ),
})

function LoginPage() {
  const { isLoading, loadingMessage } = useLoading();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img src="/logo.png" alt="Emlak Yönetim" className="mx-auto h-12 w-auto" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Hesabınıza Giriş Yapın
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Devam etmek için lütfen giriş yapınız
          </p>
        </div>
        <div className="bg-white py-8 px-6 shadow-lg rounded-lg">
          <LoginForm />
        </div>
      </div>
      <LoadingModal isOpen={isLoading} message={loadingMessage} />
    </div>
  )
}
